import React from 'react';
import { google, slack, atlassian, dropbox, shopify } from './imports';
import './brand.css';

const Brand = () => (
  <div className="gpt3__brand section__padding">
    <div>
      <img />
    </div>
    <div>
      <img />
    </div>
    <div>
      <img />
    </div>
    <div>
      <img />
    </div>
    <div>
      <img />
    </div>
  </div>
);

export default Brand;
